package com.example.monetix.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

actual class ReceiptScanner {
    actual suspend fun scanImage(uriString: String): ReceiptData {
        return ReceiptData(total = null, merchant = null, date = null)
    }
}

@Composable
actual fun rememberReceiptScanner(): ReceiptScanner {
    return remember { ReceiptScanner() }
}